import { UserProfileShortPopoverTrigger } from '@modules/user/UserProfileShortPopoverTrigger';
import { Box, styled } from '@mui/material';
import type { IConversationMessage } from 'src/@types/conversation';
import { CPAvatar } from 'src/components/base/CPAvatar';
import { formatMessageTime } from '../shared/utils';

type Props = {
  sender: {
    _id: string;
    name: string;
    picture?: string;
  };
  message: IConversationMessage;
  hideAuthor?: boolean;
};

export const ChatMessageAuthorDisplay = ({
  sender,
  message,
  hideAuthor,
}: Props) => {
  if (hideAuthor || !sender) {
    return (
      <StyledMessageTime className="hoverShow">
        {formatMessageTime(message.createdAt)}
      </StyledMessageTime>
    );
  }

  return (
    <Box pl={1}>
      <UserProfileShortPopoverTrigger userId={sender._id}>
        <CPAvatar picture={sender.picture} name={sender.name} />
      </UserProfileShortPopoverTrigger>
    </Box>
  );
};

const StyledMessageTime = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));
